import * as PIXI from 'pixi.js';
import {
	Settings
} from './Settings'

export const hashName = name => {
    if(window.__assetHashNames && typeof window.__assetHashNames === 'object' && window.__assetHashNames !== null){
        if(window.__assetHashNames[name]) return window.__assetHashNames[name];
    }
    return name;
}

const CORE_ASSETS = [
    { alias: "Characters_1.json", src: `assets/images/characters/${hashName('Characters_1.json')}` },
    { alias: "Characters_Gore.json", src: `assets/images/characters/${hashName('Characters_Gore.json')}` },
    { alias: "Masks.json", src: `assets/images/characters/${hashName('Masks.json')}` },
    { alias: "Vehicles_1.json", src: `assets/images/vehicles/${hashName('Vehicles_1.json')}` },
    { alias: "Mech.json", src: `assets/images/vehicles/${hashName('Mech.json')}` },
    { alias: "Movement.json", src: `assets/images/prefabs/${hashName('Movement.json')}` },
    { alias: "Construction.json", src: `assets/images/prefabs/${hashName('Construction.json')}` },
    { alias: "Nature.json", src: `assets/images/prefabs/${hashName('Nature.json')}` },
    { alias: "Weapons.json", src: `assets/images/prefabs/${hashName('Weapons.json')}` },
    { alias: "Misc.json", src: `assets/images/prefabs/${hashName('Misc.json')}` },
    { alias: "Level.json", src: `assets/images/prefabs/${hashName('Level.json')}` },
    { alias: "textures.json", src: `assets/images/textures/${hashName('textures.json')}` },
    /*TILE DATA*/
    { alias: "rope.png", src: `assets/images/misc/${hashName('rope.png')}` },
    /*PARTICLE DATA*/
    { alias: "particles.json", src: `assets/images/particles/${hashName('particles.json')}` },
    /*MISC*/
    { alias: "iconSet.json", src: `assets/images/gui/${hashName('iconSet.json')}` },
];

export const LoadCoreAssets = async function (onProgress){
    for (const asset of CORE_ASSETS) PIXI.Assets.add(asset);
    return PIXI.Assets.load(CORE_ASSETS.map(a => a.alias), onProgress);
}

// Replacement for the v6 `loader.resources[alias]` lookups: returns the loaded
// asset (a Spritesheet for the atlas jsons, a Texture for plain images).
export const getAsset = alias => PIXI.Assets.get(alias);

export const ExtractTextureAssets = async () => {
    const textureSheet = PIXI.Assets.get("textures.json");
    const sheetImage = textureSheet.textureSource.resource;

    const tempCanvas = document.createElement('canvas');
    const tempCTX = tempCanvas.getContext('2d');
    const textureSize = 128;
    tempCanvas.width = tempCanvas.height = textureSize;
    const keys = Object.keys(textureSheet.textures);

    for(let i = 0; i< keys.length; i++){
        const key = keys[i];
        const texture = textureSheet.textures[key];
        tempCTX.clearRect(0, 0, textureSize, textureSize);
        tempCTX.drawImage(
            sheetImage,
            texture.frame.x,
            texture.frame.y,
            textureSize,
            textureSize,
            0,
            0,
            textureSize,
            textureSize
        );


        const image = await new Promise(resolve => {
            const image = new Image();
            image.alt = Settings.textureNames[i+1];
            image.src = tempCanvas.toDataURL();
            image.onload = ()=>{resolve(image)};
        });

        const tex = PIXI.Texture.from(image);
        tex.label = Settings.textureNames[i+1]; // replaces v6 textureCacheIds lookups

        // registers the texture so PIXI.Texture.from(name) keeps working
        PIXI.Cache.set(Settings.textureNames[i+1], tex);

    };
}
